import React, { useCallback, useState } from 'react';
import { Button } from 'react-bootstrap';
import ArticleCreate from './ArticleCreate';
import ArticleList from './ArticleList';
import ArticleDetail from './ArticleDetail';
import ArticleGroupManagement from './ArticleGroupManagement';
import { useUser } from '../../context/UserContext';
import { useTenant } from '../../context/TenantContext';
import { useMembership } from '../../context/MembershipContext';
import {
  canCreateContentForTenant,
  isTenantAdminForTenant,
} from '../../platform/membershipPermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import useBrowserBackStack from '../../hooks/useBrowserBackStack';
import './Article.css';

function Article() {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [showCreateArticle, setShowCreateArticle] = useState(false);
  const [showGroupManagement, setShowGroupManagement] = useState(false);

  const { user } = useUser();
  const { tenantId } = useTenant();
  const { memberships } = useMembership();

  const isAdmin = isTenantAdminForTenant(memberships, tenantId, user);
  const canCreate = canCreateContentForTenant(memberships, tenantId, user);

  const handleSelectArticle = (article) => {
    setSelectedArticle(article);
    setShowCreateArticle(false);
    setShowGroupManagement(false);
  };

  const resetToList = useCallback(() => {
    setSelectedArticle(null);
    setShowCreateArticle(false);
    setShowGroupManagement(false);
  }, []);

  const onList = !selectedArticle && !showCreateArticle && !showGroupManagement;
  const closeDetailView = useBrowserBackStack(!onList, resetToList);

  const toggleCreateArticleForm = () => {
    if (showCreateArticle) {
      closeDetailView();
      return;
    }
    setShowCreateArticle(true);
    setSelectedArticle(null);
    setShowGroupManagement(false);
  };

  const toggleGroupManagement = () => {
    if (showGroupManagement) {
      closeDetailView();
      return;
    }
    setShowGroupManagement(true);
    setSelectedArticle(null);
    setShowCreateArticle(false);
  };

  const handleArticleCreated = () => {
    setShowCreateArticle(false);
    setSelectedArticle(null);
  };

  const headerTitle = selectedArticle?.title
    || (showCreateArticle ? 'Dodaj obrazec' : (showGroupManagement ? 'Uredi skupine' : 'Obrazci'));

  return (
    <div className="platform-module-container article-container">
        <ModulePageHeader
          eyebrow={!onList ? 'Obrazci' : undefined}
          title={headerTitle}
          subtitle={onList ? 'Obrazci in vloge za podpis ter prenos.' : undefined}
          actions={(
            <>
              {onList && isAdmin && (
                <Button variant="primary" onClick={toggleGroupManagement}>
                  Uredi skupine
                </Button>
              )}
              {!selectedArticle && canCreate && (
                <Button variant="primary" onClick={toggleCreateArticleForm}>
                  {showCreateArticle ? 'Nazaj na obrazce' : 'Dodaj obrazec'}
                </Button>
              )}
              {selectedArticle && (
                <Button variant="primary" onClick={closeDetailView}>Nazaj na obrazce</Button>
              )}
              {showGroupManagement && (
                <Button variant="primary" onClick={closeDetailView}>Nazaj na obrazce</Button>
              )}
            </>
          )}
        />
        {!selectedArticle ? (
          showGroupManagement ? (
            <ArticleGroupManagement />
          ) : showCreateArticle ? (
            <ArticleCreate onArticleCreated={handleArticleCreated} />
          ) : (
            <ArticleList onSelectArticle={handleSelectArticle} />
          )
        ) : (
          <ArticleDetail article={selectedArticle} />
        )}
    </div>
  );
}

export default Article;
